<div class="wrapper-title-bar">
  <div class="wrapper-title">
    <span>
      {{ title() | translate }}
    </span>
  </div>
  <div class="wrapper-actions">
    @for (action of actions(); track action.name) {
      <button
        [ngClass]="{ disabled: !action.enable }"
        [title]="action.text | translate"
        class="action"
        (click)="onActionClick(action)"
      >
        <i class="fal fa-{{ action.icon }}"></i>
      </button>
    }
  </div>
</div>
